/// <reference path="../assets.d.ts" />
import { Asset } from 'expo-asset';
import type { ImageSource } from '../image.types';
import landscapeDarkAsset from './landscape-dark.webp';

// Web variant. The bundled WebP's URL, which the image layer fetches.
export const landscapeDark: ImageSource = Asset.fromModule(landscapeDarkAsset).uri;
